export const isLightboxOpen = (state = false, action) => {
  switch (action.type) {
    case `LIGHTBOX_OPEN`:
      state = true
      return state
    case `LIGHTBOX_CLOSE`:
      state = false
      return state
    default:
      return state
  }
}

export const isBrowserWarningClosed = (state = false, action) => {
  switch (action.type) {
    case `BROWSER_WARNING_CLOSE`:
      state = true
      return state
    default:
      return state
  }
}
